import renderInputField from 'components/FormControls/textInput'
import { Spinner } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Field } from 'redux-form'
import { GET_ORGANIZATION_BANK } from 'modules/Finance/PaymentProfiles/store/types'

const BicField = ({ form }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)

  const handleChange = useCallback(
    (e, newValue, prevValue) => {
      if (!newValue !== prevValue) {
        new Promise((resolve) => {
          setLoading(true)
          dispatch({
            type: GET_ORGANIZATION_BANK,
            meta: { resolve },
            payload: { bic: newValue },
            formName: form,
          })
        }).finally(() => {
          setLoading(false)
        })
      }
    },
    [form],
  )
  return (
    <Field
      fullWidth
      name="details.bic"
      component={renderInputField}
      onChange={handleChange}
      label={t('payment_profiles::new.fields.details.bic.label')}
      normalize={(value) => value.replace(/\D/g, '').substr(0, 9) ?? ''}
      t={t}
      InputProps={{
        endAdornment: loading ? (
          <Spinner
            width={16}
            color={'Label-GU-Primary'}
          />
        ) : null,
      }}
    />
  )
}

export default BicField

BicField.propTypes = {
  form: PropTypes.string,
}
